<svelte:options accessors={true}/>
<script>
import { createEventDispatcher } from 'svelte';

export let state = '';
export let text = '';

let klass = '';
export { klass as class };

const dispatch = createEventDispatcher()

function Click()
{
    /*
    dispatch('message', {
			text: 'Hello!'
	});
    */

}

</script>

<button type="submit" class={"root " + klass} class:disabled={state === 'disabled' || state === 'loading'}>
{#if state === 'loading'}
    <div class="spinner"></div>
{:else}
    {text}
{/if}
</button>

<style>
div
{
    color: white;
}

@keyframes spinnerRotation {
  from{
    transform: rotate(0deg);
  }
  to{
    transform: rotate(360deg);
  }
}


button.root
{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff !important;
}

.spinner
{
    display: inline-block;
    width: 30px !important;
    height: 30px !important;
    border: 2px solid transparent;
    border-top-color: white;
    border-bottom-color: white;
    border-radius: 50%;
    animation: spinnerRotation .8s ease infinite;
}

</style>
